import { useLinkTo, useRoute } from '@react-navigation/native';
import { useGlobalConfig } from 'context/GlobalContext';
import { LinearGradient } from 'expo-linear-gradient';
import { useSelectedProfile } from 'hooks/useSelectedProfile';
import { Image, Pressable, View, useWindowDimensions } from 'react-native';
import { HeaderProps } from 'types';
import { getResponsiveSize } from 'utils/index';
import { Platform } from 'utils/platform';

import MenuNavigation from './Navigation.web';
import SuperiorNavbar from './SuperiorNavbar';
import useSuperiorNavbar from './helpers/useSuperiorNavbar';

import BandHeaderLogo from 'assets/LogoHeader.png';

import HeaderMenuRightArea from 'components/Header/HeaderRightArea';
import { usePlayer } from 'components/Player/context';

const Header: React.FC<Omit<HeaderProps, 'showScreenName'>> = ({ sticky = false }) => {
  const { isFullScreen: isVideoInFullScreen } = usePlayer();
  const route = useRoute();
  const linkTo = useLinkTo();
  const { colors, isScrollingDown } = useGlobalConfig();
  const { width: screenWidth } = useWindowDimensions();
  const blurStyle = { backdropFilter: 'blur(8px)' } as any;
  const hasSuperiorNavbar = useSuperiorNavbar(route);
  const { isRestrictedProfile, isFetching } = useSelectedProfile();

  const isSuperiorNavbarVisible =
    hasSuperiorNavbar && !isRestrictedProfile && !Platform.isTV && screenWidth < 480;

  if (isVideoInFullScreen && Platform.OS !== 'web') {
    return null;
  }

  return (
    <View>
      <View
        id={sticky ? 'header-sticky' : 'header'}
        style={[
          {
            top: 0,
            width: '100%',
            height: getResponsiveSize({ lg: 80, base: 45 }),
            backgroundColor: isScrollingDown
              ? 'rgba(7, 13, 49, 0.8)'
              : isSuperiorNavbarVisible
              ? '#070d31'
              : 'transparent',
            zIndex: 100,
            paddingHorizontal: getResponsiveSize({ lg: 45, base: 20 }),
            justifyContent: 'center',
          },
          isScrollingDown && blurStyle,
        ]}>
        {!isScrollingDown && (
          <LinearGradient
            start={{ x: 0, y: 1 }}
            end={{ x: 0, y: 0 }}
            tvParallaxShiftDistanceX={10}
            colors={['transparent', colors || '#070d31']}
            style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }}
          />
        )}
        <View
          style={{
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <View
            style={{
              alignItems: getResponsiveSize({
                lg: 'center',
                md: 'center',
                sm: 'center',
                base: 'flex-start',
              }),
              gap: getResponsiveSize({ lg: 55, md: 35, sm: 25, base: 8 }),
              flexDirection: getResponsiveSize({ lg: 'row', md: 'row', sm: 'row', base: 'column' }),
            }}>
            <Pressable onPress={() => linkTo('/')}>
              <Image
                source={BandHeaderLogo}
                style={{
                  width: Number(getResponsiveSize({ lg: 216, base: 100 })),
                  height: Number(getResponsiveSize({ lg: 47, base: 22 })),
                }}
              />
            </Pressable>
            {!isRestrictedProfile && !isFetching && <MenuNavigation />}
          </View>

          <HeaderMenuRightArea />
        </View>
      </View>
      {isSuperiorNavbarVisible && <SuperiorNavbar />}
    </View>
  );
};

export default Header;
